/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  isProgramError,
  type Address,
  type SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM,
  type SolanaError,
} from '@solana/kit';
import { STAKE_POOL_PROGRAM_ADDRESS } from '../programs';

/** DeserializationError: Error deserializing an account */
export const STAKE_POOL_ERROR__DESERIALIZATION_ERROR = 0x0; // 0
/** SerializationError: Error serializing an account */
export const STAKE_POOL_ERROR__SERIALIZATION_ERROR = 0x1; // 1
/** InvalidProgramOwner: Invalid program owner */
export const STAKE_POOL_ERROR__INVALID_PROGRAM_OWNER = 0x2; // 2
/** InvalidPda: Invalid PDA derivation */
export const STAKE_POOL_ERROR__INVALID_PDA = 0x3; // 3
/** ExpectedEmptyAccount: Expected empty account */
export const STAKE_POOL_ERROR__EXPECTED_EMPTY_ACCOUNT = 0x4; // 4
/** ExpectedNonEmptyAccount: Expected non empty account */
export const STAKE_POOL_ERROR__EXPECTED_NON_EMPTY_ACCOUNT = 0x5; // 5
/** ExpectedSignerAccount: Expected signer account */
export const STAKE_POOL_ERROR__EXPECTED_SIGNER_ACCOUNT = 0x6; // 6
/** ExpectedWritableAccount: Expected writable account */
export const STAKE_POOL_ERROR__EXPECTED_WRITABLE_ACCOUNT = 0x7; // 7
/** AccountMismatch: Account mismatch */
export const STAKE_POOL_ERROR__ACCOUNT_MISMATCH = 0x8; // 8
/** InvalidAccountKey: Invalid account key */
export const STAKE_POOL_ERROR__INVALID_ACCOUNT_KEY = 0x9; // 9
/** NumericalOverflow: Numerical overflow */
export const STAKE_POOL_ERROR__NUMERICAL_OVERFLOW = 0xa; // 10
/** PoolPaused: Pool is paused */
export const STAKE_POOL_ERROR__POOL_PAUSED = 0xb; // 11
/** AmountBelowMinimum: Amount below minimum stake */
export const STAKE_POOL_ERROR__AMOUNT_BELOW_MINIMUM = 0xc; // 12
/** InsufficientStakedBalance: Insufficient staked balance */
export const STAKE_POOL_ERROR__INSUFFICIENT_STAKED_BALANCE = 0xd; // 13
/** LockupNotExpired: Lockup period not expired */
export const STAKE_POOL_ERROR__LOCKUP_NOT_EXPIRED = 0xe; // 14
/** InsufficientRewards: Insufficient rewards in pool */
export const STAKE_POOL_ERROR__INSUFFICIENT_REWARDS = 0xf; // 15
/** Unauthorized: Unauthorized */
export const STAKE_POOL_ERROR__UNAUTHORIZED = 0x10; // 16
/** InvalidTokenProgram: Invalid token program */
export const STAKE_POOL_ERROR__INVALID_TOKEN_PROGRAM = 0x11; // 17
/** InvalidMint: Invalid mint */
export const STAKE_POOL_ERROR__INVALID_MINT = 0x12; // 18
/** InvalidAccountDiscriminator: Invalid account discriminator */
export const STAKE_POOL_ERROR__INVALID_ACCOUNT_DISCRIMINATOR = 0x13; // 19
/** PoolParametersChanged: Pool parameters changed (frontrunning protection) */
export const STAKE_POOL_ERROR__POOL_PARAMETERS_CHANGED = 0x14; // 20
/** NoPendingAuthority: No pending authority transfer */
export const STAKE_POOL_ERROR__NO_PENDING_AUTHORITY = 0x15; // 21
/** InvalidPendingAuthority: Invalid pending authority */
export const STAKE_POOL_ERROR__INVALID_PENDING_AUTHORITY = 0x16; // 22
/** PoolEnded: Pool has ended (no new stakes allowed) */
export const STAKE_POOL_ERROR__POOL_ENDED = 0x17; // 23
/** InvalidParameters: Invalid parameters */
export const STAKE_POOL_ERROR__INVALID_PARAMETERS = 0x18; // 24
/** InvalidVaultOwner: Invalid vault owner (vault must be owned by pool PDA) */
export const STAKE_POOL_ERROR__INVALID_VAULT_OWNER = 0x19; // 25
/** UnsafeTokenExtension: Unsafe Token-2022 extension detected */
export const STAKE_POOL_ERROR__UNSAFE_TOKEN_EXTENSION = 0x1a; // 26
/** UnexpectedBalanceChange: Unexpected token balance change during transfer */
export const STAKE_POOL_ERROR__UNEXPECTED_BALANCE_CHANGE = 0x1b; // 27
/** MintHasFreezeAuthority: Mint has freeze authority (can lock user funds) */
export const STAKE_POOL_ERROR__MINT_HAS_FREEZE_AUTHORITY = 0x1c; // 28
/** RewardRateChangeDelayNotElapsed: Reward rate change delay not elapsed */
export const STAKE_POOL_ERROR__REWARD_RATE_CHANGE_DELAY_NOT_ELAPSED = 0x1d; // 29
/** NoPendingRewardRateChange: No pending reward rate change */
export const STAKE_POOL_ERROR__NO_PENDING_REWARD_RATE_CHANGE = 0x1e; // 30
/** PendingRewardRateChangeExists: Pending reward rate change already exists */
export const STAKE_POOL_ERROR__PENDING_REWARD_RATE_CHANGE_EXISTS = 0x1f; // 31
/** InvalidTimestamp: Invalid timestamp */
export const STAKE_POOL_ERROR__INVALID_TIMESTAMP = 0x20; // 32
/** DataCorruption: Data corruption detected (state invariant violated) */
export const STAKE_POOL_ERROR__DATA_CORRUPTION = 0x21; // 33
/** AccountSizeTooSmall: Account size too small for serialized data */
export const STAKE_POOL_ERROR__ACCOUNT_SIZE_TOO_SMALL = 0x22; // 34
/** UnauthorizedPoolCreator: Unauthorized pool creator (only authorized admins can create pools) */
export const STAKE_POOL_ERROR__UNAUTHORIZED_POOL_CREATOR = 0x23; // 35
/** CreatorAlreadyAuthorized: Creator already authorized */
export const STAKE_POOL_ERROR__CREATOR_ALREADY_AUTHORIZED = 0x24; // 36
/** MaxAuthorizedCreatorsReached: Maximum number of authorized creators reached */
export const STAKE_POOL_ERROR__MAX_AUTHORIZED_CREATORS_REACHED = 0x25; // 37
/** CannotRemoveMainAuthority: Cannot remove main authority from authorized creators */
export const STAKE_POOL_ERROR__CANNOT_REMOVE_MAIN_AUTHORITY = 0x26; // 38
/** CreatorNotFound: Creator not found in authorized list */
export const STAKE_POOL_ERROR__CREATOR_NOT_FOUND = 0x27; // 39

export type StakePoolError =
  | typeof STAKE_POOL_ERROR__ACCOUNT_MISMATCH
  | typeof STAKE_POOL_ERROR__ACCOUNT_SIZE_TOO_SMALL
  | typeof STAKE_POOL_ERROR__AMOUNT_BELOW_MINIMUM
  | typeof STAKE_POOL_ERROR__CANNOT_REMOVE_MAIN_AUTHORITY
  | typeof STAKE_POOL_ERROR__CREATOR_ALREADY_AUTHORIZED
  | typeof STAKE_POOL_ERROR__CREATOR_NOT_FOUND
  | typeof STAKE_POOL_ERROR__DATA_CORRUPTION
  | typeof STAKE_POOL_ERROR__DESERIALIZATION_ERROR
  | typeof STAKE_POOL_ERROR__EXPECTED_EMPTY_ACCOUNT
  | typeof STAKE_POOL_ERROR__EXPECTED_NON_EMPTY_ACCOUNT
  | typeof STAKE_POOL_ERROR__EXPECTED_SIGNER_ACCOUNT
  | typeof STAKE_POOL_ERROR__EXPECTED_WRITABLE_ACCOUNT
  | typeof STAKE_POOL_ERROR__INSUFFICIENT_REWARDS
  | typeof STAKE_POOL_ERROR__INSUFFICIENT_STAKED_BALANCE
  | typeof STAKE_POOL_ERROR__INVALID_ACCOUNT_DISCRIMINATOR
  | typeof STAKE_POOL_ERROR__INVALID_ACCOUNT_KEY
  | typeof STAKE_POOL_ERROR__INVALID_MINT
  | typeof STAKE_POOL_ERROR__INVALID_PARAMETERS
  | typeof STAKE_POOL_ERROR__INVALID_PDA
  | typeof STAKE_POOL_ERROR__INVALID_PENDING_AUTHORITY
  | typeof STAKE_POOL_ERROR__INVALID_PROGRAM_OWNER
  | typeof STAKE_POOL_ERROR__INVALID_TIMESTAMP
  | typeof STAKE_POOL_ERROR__INVALID_TOKEN_PROGRAM
  | typeof STAKE_POOL_ERROR__INVALID_VAULT_OWNER
  | typeof STAKE_POOL_ERROR__LOCKUP_NOT_EXPIRED
  | typeof STAKE_POOL_ERROR__MAX_AUTHORIZED_CREATORS_REACHED
  | typeof STAKE_POOL_ERROR__MINT_HAS_FREEZE_AUTHORITY
  | typeof STAKE_POOL_ERROR__NO_PENDING_AUTHORITY
  | typeof STAKE_POOL_ERROR__NO_PENDING_REWARD_RATE_CHANGE
  | typeof STAKE_POOL_ERROR__NUMERICAL_OVERFLOW
  | typeof STAKE_POOL_ERROR__PENDING_REWARD_RATE_CHANGE_EXISTS
  | typeof STAKE_POOL_ERROR__POOL_ENDED
  | typeof STAKE_POOL_ERROR__POOL_PARAMETERS_CHANGED
  | typeof STAKE_POOL_ERROR__POOL_PAUSED
  | typeof STAKE_POOL_ERROR__REWARD_RATE_CHANGE_DELAY_NOT_ELAPSED
  | typeof STAKE_POOL_ERROR__SERIALIZATION_ERROR
  | typeof STAKE_POOL_ERROR__UNAUTHORIZED
  | typeof STAKE_POOL_ERROR__UNAUTHORIZED_POOL_CREATOR
  | typeof STAKE_POOL_ERROR__UNEXPECTED_BALANCE_CHANGE
  | typeof STAKE_POOL_ERROR__UNSAFE_TOKEN_EXTENSION;

let stakePoolErrorMessages: Record<StakePoolError, string> | undefined;
if (process.env.NODE_ENV !== 'production') {
  stakePoolErrorMessages = {
    [STAKE_POOL_ERROR__ACCOUNT_MISMATCH]: `Account mismatch`,
    [STAKE_POOL_ERROR__ACCOUNT_SIZE_TOO_SMALL]: `Account size too small for serialized data`,
    [STAKE_POOL_ERROR__AMOUNT_BELOW_MINIMUM]: `Amount below minimum stake`,
    [STAKE_POOL_ERROR__CANNOT_REMOVE_MAIN_AUTHORITY]: `Cannot remove main authority from authorized creators`,
    [STAKE_POOL_ERROR__CREATOR_ALREADY_AUTHORIZED]: `Creator already authorized`,
    [STAKE_POOL_ERROR__CREATOR_NOT_FOUND]: `Creator not found in authorized list`,
    [STAKE_POOL_ERROR__DATA_CORRUPTION]: `Data corruption detected (state invariant violated)`,
    [STAKE_POOL_ERROR__DESERIALIZATION_ERROR]: `Error deserializing an account`,
    [STAKE_POOL_ERROR__EXPECTED_EMPTY_ACCOUNT]: `Expected empty account`,
    [STAKE_POOL_ERROR__EXPECTED_NON_EMPTY_ACCOUNT]: `Expected non empty account`,
    [STAKE_POOL_ERROR__EXPECTED_SIGNER_ACCOUNT]: `Expected signer account`,
    [STAKE_POOL_ERROR__EXPECTED_WRITABLE_ACCOUNT]: `Expected writable account`,
    [STAKE_POOL_ERROR__INSUFFICIENT_REWARDS]: `Insufficient rewards in pool`,
    [STAKE_POOL_ERROR__INSUFFICIENT_STAKED_BALANCE]: `Insufficient staked balance`,
    [STAKE_POOL_ERROR__INVALID_ACCOUNT_DISCRIMINATOR]: `Invalid account discriminator`,
    [STAKE_POOL_ERROR__INVALID_ACCOUNT_KEY]: `Invalid account key`,
    [STAKE_POOL_ERROR__INVALID_MINT]: `Invalid mint`,
    [STAKE_POOL_ERROR__INVALID_PARAMETERS]: `Invalid parameters`,
    [STAKE_POOL_ERROR__INVALID_PDA]: `Invalid PDA derivation`,
    [STAKE_POOL_ERROR__INVALID_PENDING_AUTHORITY]: `Invalid pending authority`,
    [STAKE_POOL_ERROR__INVALID_PROGRAM_OWNER]: `Invalid program owner`,
    [STAKE_POOL_ERROR__INVALID_TIMESTAMP]: `Invalid timestamp`,
    [STAKE_POOL_ERROR__INVALID_TOKEN_PROGRAM]: `Invalid token program`,
    [STAKE_POOL_ERROR__INVALID_VAULT_OWNER]: `Invalid vault owner (vault must be owned by pool PDA)`,
    [STAKE_POOL_ERROR__LOCKUP_NOT_EXPIRED]: `Lockup period not expired`,
    [STAKE_POOL_ERROR__MAX_AUTHORIZED_CREATORS_REACHED]: `Maximum number of authorized creators reached`,
    [STAKE_POOL_ERROR__MINT_HAS_FREEZE_AUTHORITY]: `Mint has freeze authority (can lock user funds)`,
    [STAKE_POOL_ERROR__NO_PENDING_AUTHORITY]: `No pending authority transfer`,
    [STAKE_POOL_ERROR__NO_PENDING_REWARD_RATE_CHANGE]: `No pending reward rate change`,
    [STAKE_POOL_ERROR__NUMERICAL_OVERFLOW]: `Numerical overflow`,
    [STAKE_POOL_ERROR__PENDING_REWARD_RATE_CHANGE_EXISTS]: `Pending reward rate change already exists`,
    [STAKE_POOL_ERROR__POOL_ENDED]: `Pool has ended (no new stakes allowed)`,
    [STAKE_POOL_ERROR__POOL_PARAMETERS_CHANGED]: `Pool parameters changed (frontrunning protection)`,
    [STAKE_POOL_ERROR__POOL_PAUSED]: `Pool is paused`,
    [STAKE_POOL_ERROR__REWARD_RATE_CHANGE_DELAY_NOT_ELAPSED]: `Reward rate change delay not elapsed`,
    [STAKE_POOL_ERROR__SERIALIZATION_ERROR]: `Error serializing an account`,
    [STAKE_POOL_ERROR__UNAUTHORIZED]: `Unauthorized`,
    [STAKE_POOL_ERROR__UNAUTHORIZED_POOL_CREATOR]: `Unauthorized pool creator (only authorized admins can create pools)`,
    [STAKE_POOL_ERROR__UNEXPECTED_BALANCE_CHANGE]: `Unexpected token balance change during transfer`,
    [STAKE_POOL_ERROR__UNSAFE_TOKEN_EXTENSION]: `Unsafe Token-2022 extension detected`,
  };
}

export function getStakePoolErrorMessage(code: StakePoolError): string {
  if (process.env.NODE_ENV !== 'production') {
    return (stakePoolErrorMessages as Record<StakePoolError, string>)[code];
  }

  return 'Error message not available in production bundles.';
}

export function isStakePoolError<TProgramErrorCode extends StakePoolError>(
  error: unknown,
  transactionMessage: {
    instructions: Record<number, { programAddress: Address }>;
  },
  code?: TProgramErrorCode
): error is SolanaError<typeof SOLANA_ERROR__INSTRUCTION_ERROR__CUSTOM> &
  Readonly<{ context: Readonly<{ code: TProgramErrorCode }> }> {
  return isProgramError<TProgramErrorCode>(
    error,
    transactionMessage,
    STAKE_POOL_PROGRAM_ADDRESS,
    code
  );
}
